import { SubHeaderProps } from "./types";
import { SubHeaderView } from "./view";

export const SubHeader = (props: SubHeaderProps) => {
	return <SubHeaderView>{props.children}</SubHeaderView>;
};
